export const AGE_QUESTION = 'Select your age'
export const SECTION_NUMBER = 1

export const AGE_OPTIONS = [
  { key: '20', i18nKey: 'onboarding.age.options.first' },
  { key: '30', i18nKey: 'onboarding.age.options.second' },
  { key: '40', i18nKey: 'onboarding.age.options.third' },
  { key: '50', i18nKey: 'onboarding.age.options.fourth' },
  { key: '60', i18nKey: 'onboarding.age.options.fifth' },
  { key: '65', i18nKey: 'onboarding.age.options.sixth' },
] as const
